import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-88d0da96")

_pushScopeId("data-v-88d0da96")
const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = { class: "px-8 py-4 flex flex-col lg:flex-row justify-between lg:items-center gap-2 lg:gap-0" }
const _hoisted_3 = { class: "flex flex-col md:flex-row flex-wrap lg:flex-nowrap text-12px xxl:text-14px items-start lg:items-center w-full md:w-auto" }
const _hoisted_4 = { class: "font-semibold text-20px mb-2 mr-4 lg:mb-0 whitespace-nowrap text-black-lp-200 capitalize w-full lg:w-auto" }
const _hoisted_5 = { class: "flex flex-row lg:items-center w-full md:gap-0 lg:w-auto justify-end" }
const _hoisted_6 = {
  key: 0,
  class: "relative mr-3"
}
const _hoisted_7 = { class: "text-12px xxl:text-14px font-medium whitespace-nowrap" }
const _hoisted_8 = {
  class: "absolute z-50 mt-1 right-0 bg-white border border-gray-lp-400 rounded-lg shadow-sm py-1",
  style: {"min-width":"200px"}
}
const _hoisted_9 = { class: "inline-flex" }
const _hoisted_10 = { class: "bg-gray-lp-1000 pt-5 pb-10 px-8 h-full" }
const _hoisted_11 = { class: "flex flex-col h-full bg-white rounded-xl overflow-hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_AdvanceFilter = _resolveComponent("AdvanceFilter")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getCurrentRoute), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('bulkBooking.searchPlaceholder'),
          class: "w-60 mr-4"
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_AdvanceFilter, {
          class: "mr-3",
          onChangeFilter: _ctx.onChangeAdvancedFilter,
          onResetFilter: _ctx.onResetAdvancedFilter
        }, null, 8, ["onChangeFilter", "onResetFilter"]),
        (_ctx.shouldShowDownloadTemplateBtn)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", {
                class: "bg-white rounded-md border border-gray-lp-400 flex items-center px-4 py-2.5 cursor-pointer gap-2",
                "data-testid": "bulk-booking-list-dropdown-download-template",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDownloadMenu = !_ctx.showDownloadMenu))
              }, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("bulkBooking.downloadTemplate")), 1),
                _createVNode(_component_Icons, {
                  name: _ctx.showDownloadMenu ? 'chevron-up-new' : 'chevron-down-new',
                  width: "16",
                  height: "16",
                  color: "#4D4D4D"
                }, null, 8, ["name"])
              ]),
              _withDirectives(_createVNode("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulkDownloadBucketStorage, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item.url,
                    class: "flex gap-2 px-4 py-2.5 cursor-pointer hover:bg-gray-lp-1000 text-sm text-black-lp-300 whitespace-nowrap",
                    "data-testid": "bulk-booking-list-menu-download-template-retail-international",
                    onClick: ($event: any) => (_ctx.downloadTemplate(_ctx.downloadTemplateName(item.name), item.url))
                  }, [
                    _createVNode(_component_Icons, {
                      name: "download-new",
                      class: "w-5 text-gray-lp-600"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.downloadTemplateName(item.name)), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.showDownloadMenu]
              ])
            ], 512)), [
              [_directive_click_outside, () => (_ctx.showDownloadMenu = false)]
            ])
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_LpButton, {
            title: _ctx.$t('bulkBooking.uploadBulkBooking'),
            color: "red-lp-100",
            textColor: "white",
            fontWeight: "semibold",
            onClick: _ctx.goToUploadBulkBooking,
            textSize: "14",
            isWidthFull: ""
          }, null, 8, ["title", "onClick"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_TableV2, {
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pagination = $event)),
          loading: _ctx.listBookingUtils().isLoading,
          columns: _ctx.columns,
          data: _ctx.listBookingUtils().dataTable,
          "data-testid": "booking-bulk-v2-list-table",
          class: "my-2 rounded-xl",
          errorCause: _ctx.errorCause,
          onRequest: _ctx.onRequestFetchBulkBookingList,
          borderTop: false,
          totalColumnFreeze: 1,
          pinnedSubstractHeight: "220px",
          paginationStyle: "v3",
          bgHeader: "bg-white",
          isBorderOnHeadBgWhite: "",
          isNoPaddingBottom: "",
          customClassPagination: "w-full h-full flex items-end px-3",
          isSpaceTop: false,
          paginationV3PaddingVertical: "pb-4 pt-5",
          compactDesign: ""
        }, null, 8, ["pagination", "loading", "columns", "data", "errorCause", "onRequest"])
      ])
    ])
  ]))
})